<template>
    <svg class="logo-bullet" :width="width || 38" :height="width || 38" viewBox="0 0 39 38" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
            <path d="M39 19c0 10.493-8.73 19-19.5 19S0 29.493 0 19h39Z" fill="#BE006E"/>
            <path d="M39 19C39 8.507 30.27 0 19.5 0S0 8.507 0 19h39Z" fill="#FA5528"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "LogoBullet",
    props: ['width'],
}
</script>

